/** Original vector coin, shared by the wallet and shop; no external asset request. */
export function MascotCoin({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 40 40" aria-hidden="true" focusable="false">
      <ellipse cx="21" cy="22" rx="17" ry="17" fill="#C27A15" />
      <circle cx="19" cy="18" r="16" fill="#FFD568" stroke="#E3A231" strokeWidth="2" />
      <circle
        cx="19"
        cy="18"
        r="11.5"
        fill="#F8B939"
        stroke="#FFF0A0"
        strokeWidth="1.5"
      />
      <path
        d="M9 12a12 12 0 0 1 9-6"
        fill="none"
        stroke="#FFF8CF"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <g fill="#AA6412">
        <ellipse cx="14.5" cy="16" rx="2.2" ry="2.8" transform="rotate(-25 14.5 16)" />
        <ellipse cx="22.5" cy="15" rx="2.2" ry="2.8" transform="rotate(20 22.5 15)" />
        <path d="M14 23c0-3 3-6 5-6s6 3 6 6c0 3-4 1-6 1s-5 2-5-1Z" />
      </g>
    </svg>
  )
}
